import { CheckMarkIcon } from '@braskai/icons';
import { Chip, Typography } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { Plan } from '@/shared/types/Billing';

import { PRICING_CARD_FEATURES } from '../../constants/pricingCardFeatures';

type TPricingCardFeaturesProps = {
  isEnterprise: boolean;
  pricingCardActivePlan: Plan;
};

export const PricingCardFeatures = ({ isEnterprise, pricingCardActivePlan }: TPricingCardFeaturesProps) => {
  const textColor = isEnterprise ? 'common.white' : 'grey.900';

  return (
    <Stack gap={8} marginTop="auto" sx={{ color: textColor }}>
      {PRICING_CARD_FEATURES[pricingCardActivePlan.category].everythingIn && (
        <Typography color={textColor} variant="body-2-md">
          {PRICING_CARD_FEATURES[pricingCardActivePlan.category].everythingIn}
        </Typography>
      )}
      {PRICING_CARD_FEATURES[pricingCardActivePlan.category].features.map(({ label, badge, highlighted }) => {
        return (
          <Stack key={label} alignItems="center" direction="row" spacing={8}>
            <CheckMarkIcon height={20} width={20} />
            <Typography
              color={textColor}
              sx={highlighted ? { fontWeight: 600 } : undefined}
              variant="body-2-md"
            >
              {label}
            </Typography>
            {badge && <Chip label={badge} color="primary" size="sm" isOutlined />}
          </Stack>
        );
      })}
    </Stack>
  );
};
